const initialState = {
  email: "",
  name: "",
  profile_image: "",
  uid: "",
  username: "",
  wallet: 0,
  favorites: [],
  metamask_account: "",
  collections: [],
};

const loggedUser = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_USER_EMAIL":
      return { ...state, email: action.value };
    case "UPDATE_USER_NAME":
      return { ...state, name: action.value };
    case "UPDATE_USER_PROFILE_IMAGE":
      return { ...state, profile_image: action.value };
    case "UPDATE_USER_UID":
      return { ...state, uid: action.value };
    case "UPDATE_USER_USERNAME":
      return { ...state, username: action.value };
    case "UPDATE_USER_WALLET":
      return { ...state, wallet: action.value };
    case "UPDATE_USER_FAVORITES":
      return { ...state, favorites: action.value };
    case "UPDATE_USER_METAMASK_ACCOUNT":
      return { ...state, metamask_account: action.value };
    case "UPDATE_USER_COLLECTIONS":
      return { ...state, collections: action.value };
    case "USER_RESET":
      return {
        email: "",
        name: "",
        profile_image: "",
        uid: "",
        username: "",
        wallet: 0,
        favorites: [],
        metamask_account: "",
        collections: [],
      };
    default:
      return state;
  }
};

export default loggedUser;
